let lenisInstance = null;

export default function lenis() {
  if (!lenisInstance) {
    lenisInstance = new Lenis({
      autoRaf: true,
      allowNestedScroll: true,
    });
  }
  return lenisInstance;
}